import { STOREFRONT_FETCH_STORE, LOADING_STOREFRONT, UPDATE_STORE_CART } from '../actionTypes';

const initialState = {
    isLoading: false,
    storefrontData: [],
    cart: [],
};

export const storefrontReducer = (state = initialState, action) => {
    switch (action.type) {
        case STOREFRONT_FETCH_STORE:
            return { ...state, storefrontData: action.payload };
        case LOADING_STOREFRONT:
            return { ...state, isLoading: action.payload };
        case UPDATE_STORE_CART:
            return { ...state, cart: action.payload }
        default:
            return state;
    }
};
